export default "__VITE_ASSET__DlmA9fII__"